<template>
  <div>
    <!-- <back-header :header="'我的报告'"></back-header> -->
    <div class="report">
      <div class="border-card" v-for="(report,index) in reportList" :key="index">
        <div class="card-header">
          <span>完成时间:{{report.updateTime}}</span>
        </div>
        <div class="card-content">
          <div class="img-box">
            <img class="quiz-thumbnail" :src="publicUrl + report.orderQuiz.quizThumbnail">
          </div>
          <div class="quiz-info">
            <div class="quiz-title"><span class="quiz-title-text">{{report.orderQuiz.quizName}}</span></div>
            <div class="quiz-name"><span class="quiz-name-text">{{report.orderQuiz.quizIntro}}</span></div>
            <div class="quiz-price"><span class="quiz-price-text">￥{{report.orderQuiz.h5SalePrice}}</span></div>
          </div>
        </div>
        <div class="card-footer">
          <van-button class="quiz-btn" color="#ffd01e" @click="goTest(report.id)">查看结果</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Button from "@m/vant/Button";
  // import BackHeader from "@c/BackHeader.vue"
  import * as api from "@p/api";
  import publicUrl from "@p/public";
  export default {
    mixins: [Button],
    data() {
      return {
        publicUrl,
        reportList: []
      }
    },
    components: {
      // 'back-header': BackHeader
    },
    created() {
      this.getReport()
    },
    methods: {
      async getReport() {
        var reports = await api.requestApiByGet('reportList')
        if (reports.code === 0) {
          this.reportList = reports.data
          console.log(this.reportList)
        }
      },
      async goTest(orderId) {
        var report = await api.requestApiByGet('withOrder', orderId)
        localStorage.setItem("orderId", orderId);
        localStorage.setItem("quizId", report.data.quizId);
        localStorage.setItem('result_' + orderId, report.data.recordDetail)
        this.$router.push({
          path: "/result"
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  .report {
    float: left;
    width: 100vw;
    padding-bottom: 70px;
    overflow: scroll;

    .border-card {
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
      transition: 0.3s;
      width: 80%;
      margin-top: 5vw;
      margin-left: 5%;
      border-radius: 10px;
      border: #aeaeae 1px;
      background-color: #ffffff;
      padding-left: 5vw;
      padding-right: 5vw;
      float: left;

      .card-header {
        line-height: 3;
        color: #aeaeae;
        font-size: 3vw;
        border-bottom: 0.3px solid #f8f8f8;
      }

      .card-content {
        padding: 5vw 0vw;
        width: 100%;
        float: left;
        border-bottom: 0.3px solid #f8f8f8;

        .img-box {
          float: left;
          width: 20vw;
          height: 20vw;

          .quiz-thumbnail {
            width: 20vw;
            height: 20vw;
            border-radius: 7px;
          }
        }

        .quiz-info {
          width: 50vw;
          height: 20vw;
          float: left;
          padding: 0 5vw;

          .quiz-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 4vw;
            height: 7vw;

            .quiz-title-text {
              height: 6vw;
              line-height: 1.8;
            }
          }

          .quiz-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 3vw;
            color: #aeaeae;
            height: 8vw;

            .quiz-name-text {
              height: 6vw;
              line-height: 1.5;
            }
          }

          .quiz-price {
            text-align: right;
            height: 6vw;
            color: red;
            line-height: 1.5;
          }
        }
      }

      .card-footer {
        width: 100%;
        height: 4vh;
        padding: 3vw 0vw;
        float: left;

        .quiz-btn {
          float: right;
          height: 4vh;
        }
      }
    }
  }
</style>
